import {call, put, select, take, takeEvery} from "redux-saga/effects";
import {
    AUTH_ERROR_INVALID_CREDENTIALS,
    AUTH_FAILED,
    AUTH_FAILED_SAGA,
    AUTH_INIT_SAGA,
    AUTH_INITIALIZED,
    AUTH_KEY_STORED,
    AUTH_LOCALSTORAGE_KEY,
    AUTH_LOGGED_OUT,
    AUTH_LOGOUT_SAGA,
    AUTH_RELOAD_VIEWER,
    AUTH_SAGA,
    AUTH_SET_TABLE_DEFINITION,
    AUTH_SET_TABLE_DEFINITION_SAGA,
    AUTH_STORE_KEY_SAGA,
    AUTH_SUCCESS,
    AUTH_SUCCESS_SAGA,
    AUTH_UPDATE_TABLE_DEFINITION_SAGA,
    AUTH_WITH_CREDENTIALS_SAGA,
} from "@/Redux/Auth/AuthConstants";
import {fetchQuery, graphql} from "relay-runtime";
import {relayAuthEnvironment} from "@/RelayEnvironment";
import {selectAllViewerTableDefinition, selectAuthToken} from "@/Redux/Auth/AuthReducer";
import _ from "lodash";
import {AuthSagasViewerQueryResponse} from "@/Redux/Auth/__generated__/AuthSagasViewerQuery.graphql";
import {getApiUrl, getAppCode, selectServerVersion} from "@/Redux/App/AppReducer";
import {
    APP_API_URL_SAGA,
    APP_SET_API_URL_INFO,
    APP_SET_SYSTEM_INFO,
    APP_SYSTEM_INFO_SAGA,
    GET_APP_DATA_SAGA,
    GET_APP_DATA_SUCCESS,
    SERVER_VERSION_DOES_NO_MATCH
} from "@/Redux/App/AppConstants";
import {
    CHANGE_STATION_START,
    CLEAR,
    DISPOSITION_RESET_FILTER_SAGA,
    DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER,
    DISPOSITION_SET_DEFAULT_VALUES,
} from "@/Redux/Disposition/Constants";


export function* authInitSaga() {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get("authToken");

    if (authToken !== null) {
        yield put({
            type: AUTH_STORE_KEY_SAGA,
            payload: {
                token: authToken,
            },
        });

        yield take(AUTH_KEY_STORED);
    }

    yield put({
        type: AUTH_SAGA,
        payload: {
            callback: () => {
            },
        },
    });

    yield take([AUTH_SUCCESS, AUTH_FAILED]);

    // Done
    yield put({
        type: AUTH_INITIALIZED,
    });
}

function handleResponse(response: {
    text: () => Promise<any>;
    ok: any;
    status: number;
    statusText: any;
}) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

function* authWithCredentialsSaga(action: any) {
    const {callback} = action.payload;

    yield put({
        type: APP_API_URL_SAGA,
    });

    yield take(APP_SET_API_URL_INFO);


    try {
        //const token: string = yield cps(SigninMutation, action.payload);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                username: action.payload.username,
                password: action.payload.password,
            }),
            headers: {
                "Content-Type": "application/json",
                authcode: getAppCode(),
            },
        };

        // @ts-ignore
        const token: string = yield fetch(getApiUrl() + "login", requestOptions)
            .then(handleResponse)
            .then((data) => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                return data.token;
            })
            .catch((error) => {
                console.error(error);
                throw Error("LoginFailed");
            });
        if (!_.isString(token)) {
            throw new Error(AUTH_ERROR_INVALID_CREDENTIALS);
        }

        yield put({
            type: AUTH_STORE_KEY_SAGA,
            payload: {
                token,
            },
        });

        yield take(AUTH_KEY_STORED);
        yield put({
            type: AUTH_SAGA,
            payload: {
                callback,
            },
        });
    } catch (e) {
        //yield call(callback, e);
        yield put({
            type: AUTH_FAILED_SAGA,
            payload: {
                error: e,
                callback: callback
            }
        });
    }
}

export function* reloadViewer(action: any) {
    const callback = () => {
    };
    const res: AuthSagasReloadViewerQueryResponse = yield fetchQuery(
        // @ts-ignore
        relayAuthEnvironment(),
        graphql`
            query AuthSagasReloadViewerQuery {
                viewer {
                    userId
                    username
                    homeStation
                    dispoDaysBefore
                    dispoDaysAfter
                    defaultLanguage
                    printname
                    defaultRegion
                    enabledGroups {
                        vehicleGroupId
                        description
                    }
                    enabledStations {
                        stationId
                        name
                        isChangeableInDispo
                    }
                    rights {
                        right
                    }
                    enabledRegions {
                        regionId
                        regions {
                            regionId
                            region
                            enabledStations {
                                stationId
                            }
                        }
                    }
                    hasMinimalRights
                    tableDefinitions {
                        data
                        formName
                        gridName
                        tableDefinitionId
                    }
                    emailSignature
                }
            }
        `,
        {},
    )
    .toPromise()
    .then((data) => {
        return data;
    })
    .catch((error) => {
        console.error(error);
        throw error;
    });
    yield put({
        type: AUTH_SUCCESS_SAGA,
        payload: {
            viewer: res.viewer,
            callback,
        },
    });
}

export function* authSaga(action: any) {
    let {callback} = action.payload;

    if (!_.isFunction(callback)) {
        callback = () => {
        };
    }

    if (_.isString(action.payload.token) && _.size(action.payload.token) > 10) {
        yield put({
            type: AUTH_STORE_KEY_SAGA,
            payload: {
                token: action.payload.token,
            },
        });

        yield take(AUTH_KEY_STORED);
    }

    try {
        const token = selectAuthToken();

        if (!_.isString(token)) {
            throw new Error("no token found");
        }

        const res: AuthSagasViewerQueryResponse = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment(),
            graphql`
                query AuthSagasViewerQuery {
                    viewer {
                        userId
                        username
                        homeStation
                        dispoDaysBefore
                        dispoDaysAfter
                        defaultLanguage
                        printname
                        defaultRegion
                        enabledGroups {
                            vehicleGroupId
                            description
                        }
                        enabledStations {
                            stationId
                            name
                            isChangeableInDispo
                        }
                        rights {
                            right
                        }
                        enabledRegions {
                            regionId
                            regions {
                                regionId
                                region
                                enabledStations {
                                    stationId
                                }
                            }
                        }
                        hasMinimalRights
                        tableDefinitions {
                            data
                            formName
                            gridName
                            tableDefinitionId
                        }
                        emailSignature
                    }
                }
            `,
            {},
        )
        .toPromise()
        .then((data) => {
            return data;
        })
        .catch((error) => {
            throw error;
        });

        if (_.isString(res.viewer?.username)) {
            // App
            yield put({
                type: APP_SYSTEM_INFO_SAGA,
            });

            yield take([APP_SET_SYSTEM_INFO, SERVER_VERSION_DOES_NO_MATCH]);

            // @ts-ignore
            const serverVersion = yield select((state) => selectServerVersion(state));


            if (_.isEmpty(serverVersion)) {
                throw Error("serverVersionNotValid");
            }

            yield put({
                type: GET_APP_DATA_SAGA,
            });
            yield take(GET_APP_DATA_SUCCESS);

            //yield put({type: AUTH_SET_TABLE_DEFINITION_SAGA, payload: res.viewer?.tableDefinitions});
            //yield take(AUTH_SET_TABLE_DEFINITION);

            yield put({
                type: AUTH_SUCCESS_SAGA,
                payload: {
                    viewer: res.viewer,
                    callback,
                },
            });
            yield put({
                type: DISPOSITION_RESET_SHOW_ONLY_GROUP_RES_OF_STATION_FILTER,
            });
            if (res.viewer?.username != localStorage.getItem("username")) {
                alert('TEST')
                const selectedStation = res.viewer?.homeStation;
                yield put({
                    type: DISPOSITION_RESET_FILTER_SAGA,
                    payload: {selectedStation},
                });
                yield take(DISPOSITION_SET_DEFAULT_VALUES);
            }
            const dispositionData: any = yield select((state) => state.disposition);
            if (!dispositionData.selectedStation) {
                yield put({
                    type: CHANGE_STATION_START,
                    payload: res.viewer?.homeStation,
                })
            }
        }
    } catch (e) {
        yield put({
            type: AUTH_FAILED_SAGA,
            payload: {
                error: e,
                callback,
            },
        });
    }
}

export function* authFailedSaga(action: any) {
    const {callback, error} = action.payload;
    yield call([localStorage, localStorage.removeItem], AUTH_LOCALSTORAGE_KEY);
    yield call(callback, error);
    yield put({
        type: AUTH_FAILED,
    });
}

export function* authStoreKeySaga(action: any) {
    const {token} = action.payload;
    yield call(
        [localStorage, localStorage.setItem],
        AUTH_LOCALSTORAGE_KEY,
        token,
    );
    yield put({
        type: AUTH_KEY_STORED,
    });
}

export function* authSuccessSaga(action: any) {
    const {viewer, callback} = action.payload;
    yield put({
        type: AUTH_SUCCESS,
        payload: {
            viewer,
        },
    });
    yield call(callback, null);
}

export function* authLogoutSaga(action: any) {
    yield call([localStorage, localStorage.removeItem], AUTH_LOCALSTORAGE_KEY);
    yield call(
        [localStorage, localStorage.removeItem],
        "CRENT_WEB/ONLY_GROUP_RES_OF_STATION",
    );
    yield put({
        type: CLEAR,
    });
    yield put({
        type: AUTH_LOGGED_OUT,
    });
}

export function* authSetTableDefinitionSaga(action: any) {
    const tableDefinition: any = [];

    for (const id in action.payload) {
        const definition = action.payload[id];

        if (!_.isArray(tableDefinition[definition.formName])) {
            tableDefinition[definition.formName] = [];
        }

        tableDefinition[definition.formName][definition.gridName] =
            definition.data;
    }

    yield put({type: AUTH_SET_TABLE_DEFINITION, payload: tableDefinition});
}

export function* authUpdateTableDefinitionSaga(action: any) {
    //@ts-ignore
    const tableDefinition = yield select((state) =>
        selectAllViewerTableDefinition(state),
    );

    if (!_.isArray(tableDefinition[action.payload.formName])) {
        tableDefinition[action.payload.formName] = [];
    }

    tableDefinition[action.payload.formName][action.payload.gridName] =
        action.payload.data;
    yield put({type: AUTH_SET_TABLE_DEFINITION, payload: tableDefinition});
}

export default function* AuthSagas() {
    yield takeEvery(AUTH_INIT_SAGA, authInitSaga);
    yield takeEvery(AUTH_SAGA, authSaga);
    yield takeEvery(AUTH_FAILED_SAGA, authFailedSaga);
    yield takeEvery(AUTH_WITH_CREDENTIALS_SAGA, authWithCredentialsSaga);
    yield takeEvery(AUTH_STORE_KEY_SAGA, authStoreKeySaga);
    yield takeEvery(AUTH_SUCCESS_SAGA, authSuccessSaga);
    yield takeEvery(AUTH_LOGOUT_SAGA, authLogoutSaga);
    yield takeEvery(AUTH_SET_TABLE_DEFINITION_SAGA, authSetTableDefinitionSaga);
    yield takeEvery(
        AUTH_UPDATE_TABLE_DEFINITION_SAGA,
        authUpdateTableDefinitionSaga,
    );
    yield takeEvery(AUTH_RELOAD_VIEWER, reloadViewer);
}
